'use client';

import React from 'react';
import dynamic from 'next/dynamic';
import { SUBMISSION_TREND, DEPT_COMPLETION, RATING_DISTRIBUTION } from '@/data/mockData';

const SubmissionTrendChart = dynamic(() => import('./charts/SubmissionTrendChart'), { ssr: false });
const DeptCompletionChart = dynamic(() => import('./charts/DeptCompletionChart'), { ssr: false });
const RatingDistributionChart = dynamic(() => import('./charts/RatingDistributionChart'), { ssr: false });

export default function DashboardCharts() {
  return (
    <div className="pn-appraisal__analytics-grid">
      {/* Submission Trend */}
      <div className="pn-appraisal__analytics-chart">
        <div className="pn-appraisal__analytics-chart-header">
          <div>
            <div className="pn-appraisal__analytics-chart-title">Submission Rate Trend</div>
            <div className="pn-appraisal__analytics-chart-subtitle">
              Annual Performance Review 2025 — weekly progress
            </div>
          </div>
          <select
            className="pn-appraisal__filter-bar-select"
            aria-label="Select cycle"
            defaultValue="cycle-001"
          >
            <option value="cycle-001">Annual Review 2025</option>
            <option value="cycle-002">Mid-Year Q2 2025</option>
            <option value="cycle-003">Probation Mar 2025</option>
          </select>
        </div>
        <SubmissionTrendChart data={SUBMISSION_TREND} />
        <div className="pn-appraisal__analytics-chart-legend">
          <div className="pn-appraisal__analytics-chart-legend-item">
            <div className="pn-appraisal__analytics-chart-legend-item-dot" style={{ background: 'var(--pn-primary)' }} />
            Cumulative Submissions
          </div>
          <div className="pn-appraisal__analytics-chart-legend-item">
            <div className="pn-appraisal__analytics-chart-legend-item-dot" style={{ background: 'var(--pn-success)', borderRadius: '50%' }} />
            Submission Rate %
          </div>
        </div>
      </div>
      {/* Dept Completion */}
      <div className="pn-appraisal__analytics-chart">
        <div className="pn-appraisal__analytics-chart-header">
          <div>
            <div className="pn-appraisal__analytics-chart-title">Department Completion</div>
            <div className="pn-appraisal__analytics-chart-subtitle">
              Submission % by department — all active cycles
            </div>
          </div>
        </div>
        <DeptCompletionChart data={DEPT_COMPLETION} />
      </div>
      {/* Rating Distribution */}
      <div className="pn-appraisal__analytics-chart">
        <div className="pn-appraisal__analytics-chart-header">
          <div>
            <div className="pn-appraisal__analytics-chart-title">Rating Distribution</div>
            <div className="pn-appraisal__analytics-chart-subtitle">277 completed appraisals</div>
          </div>
        </div>
        <RatingDistributionChart data={RATING_DISTRIBUTION} />
        <div className="pn-appraisal__analytics-chart-legend" style={{ flexDirection: 'column', gap: '6px', marginTop: '12px' }}>
          {RATING_DISTRIBUTION?.map((r) => (
            <div key={`legend-${r?.name}`} className="pn-appraisal__analytics-chart-legend-item" style={{ justifyContent: 'space-between' }}>
              <div style={{ display: 'flex', alignItems: 'center', gap: 6 }}>
                <div className="pn-appraisal__analytics-chart-legend-item-dot" style={{ background: r?.color }} />
                <span style={{ fontSize: 12 }}>{r?.name}</span>
              </div>
              <span style={{ fontSize: 12, fontWeight: 700, color: 'var(--pn-text-primary)', fontVariantNumeric: 'tabular-nums' }}>
                {r?.value}
              </span>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
}